/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    let links = project.getNodeLinks(feature, 'time_str');
    const FORMAT = feature.getSettingValue('FORMAT');

    let code = '';
    if (links.length > 0) {
        const link = links[0];
        code += `#****${link.getSourceId()}****#`;
    }

    links = project.getNodeLinks(feature, 'time_format');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
time_str=datetime_timestamp_to_string(${project.getNodeParameter(link, 'time_variable')}, "${FORMAT}")
${code}`,
        });
    }

    return blocks;
};
